import styled from "styled-components";

export const ShowMoreButtonContainer = styled.div`
  width: 100%;
  margin-top: 48px;
  display: flex;
  justify-content: center;
`;

export const ShowMoreButton = styled.button`
  background: transparent;
  padding: 16px 40px;
  border: 2px solid var(--primary);
  border-radius: 50px;
  color: var(--primary);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: var(--primary);
    transform: translate(-50%, -50%);
    transition: width 0.4s ease, height 0.4s ease;
    z-index: -1;
  }

  &:hover {
    color: #fff;
    border-color: var(--primary);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(46, 49, 146, 0.25);

    &::before {
      width: 300px;
      height: 300px;
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 14px 32px;
    font-size: 1rem;
  }
`;
